import React, { useState } from 'react';
import {
  Chart as ChartJS,
  ArcElement,
  Tooltip as ChartTooltip,
  Legend,
} from 'chart.js';
import { Pie } from 'react-chartjs-2';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import FAQSchema from '../../FAQSchema';
import AdBanner from '../AdPage/AdBanner';

// Register necessary components
ChartJS.register(
  ArcElement,
  ChartTooltip,
  Legend
);

const BobCarLoanEmiCalculator  = () => {
  const [loanAmount, setLoanAmount] = useState(500000);
  const [interestRate, setInterestRate] = useState(8);
  const [loanTenure, setLoanTenure] = useState(5);
  const [monthlyEMI, setMonthlyEMI] = useState(0);
  const [totalInterest, setTotalInterest] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [amortizationSchedule, setAmortizationSchedule] = useState([]);
  const [activeYear, setActiveYear] = useState(null);

  const calculateEMI = () => {
    const principal = loanAmount;
    const annualInterest = interestRate / 100;
    const monthlyInterest = annualInterest / 12;
    const tenureInMonths = loanTenure * 12;

    const emi =
      (principal * monthlyInterest * Math.pow(1 + monthlyInterest, tenureInMonths)) /
      (Math.pow(1 + monthlyInterest, tenureInMonths) - 1);

    const totalAmount = emi * tenureInMonths;
    const totalInterest = totalAmount - principal;

    setMonthlyEMI(emi.toFixed(2));
    setTotalInterest(totalInterest.toFixed(2));
    setTotalAmount(totalAmount.toFixed(2));

    const schedule = [];
    let balance = principal;
    // let currentYear = new Date().getFullYear();
    let currentYear = new Date().getFullYear();

    let currentMonth = 6;

    for (let i = 0; i < tenureInMonths; i++) {
      const interestForMonth = balance * monthlyInterest;
      const principalForMonth = emi - interestForMonth;
      balance -= principalForMonth;

      schedule.push({
        // month: i + 1,
        // year: year,
        month: (currentMonth + i) % 12 + 1, // Ensure month is in range 1-12
        year: currentYear + Math.floor((currentMonth + i) / 12),
        principalPaid: principalForMonth,
        interestPaid: interestForMonth,
        totalPayment: emi,
        balance: balance,
      });

      // if ((i + 1) % 12 === 0) {
      //   year++;
      // }
    }

    setAmortizationSchedule(schedule);
  };

  const handleLoanAmountChange = (e) => {
    const value = e.target.value;
    setLoanAmount(value === '' ? 0 : parseInt(value));
  };

  const handleInterestRateChange = (e) => {
    const value = e.target.value;
    setInterestRate(value === '' ? 0 : parseFloat(value));
  };

  const handleLoanTenureChange = (e) => {
    const value = e.target.value;
    setLoanTenure(value === '' ? 0 : parseInt(value));
  };

  const handleYearToggle = (year) => {
    setActiveYear(activeYear === year ? null : year);
  };

  const data = {
    labels: ['Principal Amount', 'Total Interest'],
    datasets: [
      {
        label: 'EMI Breakdown',
        data: [loanAmount, totalInterest],
        backgroundColor: ['#36A2EB', '#FF6384'],
      },
    ],
  };
function Icon({ id, open }) {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={2}
            stroke="currentColor"
            className={`${id === open ? "rotate-180" : ""} h-5 w-5 transition-transform`}
        >
            <path strokeLinecap="round" strokeLinejoin="round" d="M19.5 8.25l-7.5 7.5-7.5-7.5" />
        </svg>
    );
  }
  
  
    const [activeIndex, setActiveIndex] = useState(0);
  
     
    const faqs = [
        {
            "question": "What is the maximum tenure for a Bank of Baroda car loan?",
            "answer": "Tenure ranges from 12 to 84 months based on the loan amount and your profile."
          },
          {
            "question": "What is the current interest rate on Bank of Baroda car loans?",
            "answer": "It usually ranges from 7% to 10.5% depending on your credit score and car category."
          },
          {
            "question": "How accurate is TheFinMaster’s EMI calculator?",
            "answer": "It’s highly accurate and uses standard banking formulas. However, actual EMIs may vary slightly due to rounding and bank fees."
          },
          {
            "question": "Can I include car insurance and registration in the loan?",
            "answer": "Yes, Bank of Baroda allows financing for on-road price including insurance and registration charges."
          },
          {
            "question": "Can I use the calculator for used cars?",
            "answer": "Yes, you can enter the applicable interest rate and loan terms for used car loans."
          },
          {
            "question": "Does Bank of Baroda charge prepayment penalties?",
            "answer": "No prepayment charges for individual borrowers under floating rate loans. Fixed rate loans may attract minimal fees."
          },
          {
            "question": "How can I reduce my EMI?",
            "answer": "Increase down payment, opt for a longer tenure, or negotiate for a lower interest rate."
          },
          {
            "question": "Will the EMI change if interest rates change?",
            "answer": "Only in floating rate loans. Fixed interest loans have constant EMIs."
          },
          {
            "question": "Can I check the full amortization schedule using the calculator?",
            "answer": "Yes, theFinMaster provides a full month-wise amortization chart."
          },
          {
            "question": "Is there a minimum loan amount for BoB car loans?",
            "answer": "Yes, typically ₹1 lakh is the minimum. It may vary by region and branch policy."
          },
          {
            "question": "Is the EMI debited automatically every month?",
            "answer": "Yes, through ECS or auto-debit mandates linked to your bank account."
          },
          {
            "question": "How soon after approval does EMI start?",
            "answer": "Usually from the next month after the loan disbursement date."
          },
          {
            "question": "Does TheFinMaster store my data?",
            "answer": "No, all calculations are client-side, and we don’t store or share your data."
          },
          {
            "question": "Can NRIs apply for BoB car loans?",
            "answer": "Yes, select branches offer car loans for NRIs with additional documentation."
          },
          {
            "question": "Can I change my EMI amount later?",
            "answer": "You can restructure the loan by extending tenure or making a part-payment to reduce the EMI."
          }
        ]
    const toggleAccordion = (index) => {
      if (activeIndex === index) {
          // If the clicked question is already expanded, collapse it
          setActiveIndex(null);
      } else {
          // If the clicked question is not expanded, expand it
          setActiveIndex(index);
      };
    }
  return (
    <>
     <Helmet>
          <title>Bank of Baroda Car Loan EMI Calculator – Calculate Repayments Easily</title>
        <meta  name='description' content='Use the Bank of Baroda EMI Calculator to plan your car loan efficiently. Understand your repayment structure in seconds.'/>
        <link rel="canonical" href="https://thefinmaster.com/financial-tools-calculators/bank-of-baroda-car-loan-emi-calculator" />
        <meta name="robots" content="max-snippet:-1, max-image-preview:standard" />
        <meta name="robots" content="max-video-preview:-1" />
      </Helmet>
      <FAQSchema faqs={faqs} />
      {/* <nav className="text-gray-500 text-sm my-4 ml-10" aria-label="Breadcrumb">
      <ol className="list-none p-0 inline-flex">
        <li className="flex items-center">
          <Link to="/" className="text-blue-600 hover:text-blue-800 ">Home</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
        <li className="flex items-center">
          <Link to="/financial-tools-calculators" className="text-blue-600 hover:text-blue-800">Financial Tools Calculators</Link>
          <svg className="w-4 h-4 mx-2 text-gray-500" fill="currentColor" viewBox="0 0 20 20">
            <path fillRule="evenodd" d="M7.293 14.707a1 1 0 010-1.414L11.586 9 7.293 4.707a1 1 0 111.414-1.414l5 5a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0z" clipRule="evenodd" />
          </svg>
        </li>
          <li className="flex items-center">
          <span className="text-gray-500 ">BoB Loan EMI Calculator</span>
        </li> 
      
      </ol>
    </nav> */}
         <div className="w-full flex justify-center items-center px-4 mt-20">
  <div className="w-full max-w-5xl h-auto object-contain rounded-lg shadow-md transition duration-300 hover:scale-105">
  <AdBanner displayOrder="1" />
  </div>
</div>
        <div className='py-4'>
    <div className="container mx-auto p-4 shadow-xl rounded-md">
      <h1 className="text-2xl font-bold mb-4">BOB Car Loan EMI Calculator</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        <div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Amount</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                value={loanAmount}
                onChange={handleLoanAmountChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">₹ {loanAmount.toLocaleString()}</span>
            </div>
            <input
              type="range"
              min="0"
              max="10000000"
              value={loanAmount}
              onChange={(e) => setLoanAmount(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Rate of Interest (P.A.)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="100"
                step="0.1"
                value={interestRate}
                onChange={handleInterestRateChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{interestRate} %</span>
            </div>
            <input
              type="range"
              min="0"
              max="15"
              step="0.1"
              value={interestRate}
              onChange={(e) => setInterestRate(parseFloat(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <div className="mb-4">
            <label className="block text-gray-700 font-semibold">Loan Tenure (Years)</label>
            <div className="flex items-center">
              <input
                type="number"
                min="0"
                max="30"
                value={loanTenure}
                onChange={handleLoanTenureChange}
                className="w-1/2 p-2 border rounded mr-2"
              />
              <span className="text-gray-700">{loanTenure} Yr</span>
            </div>
            <input
              type="range"
              min="0"
              max="30"
              value={loanTenure}
              onChange={(e) => setLoanTenure(parseInt(e.target.value))}
              className="w-full mt-2"
            />
          </div>
          <button
            onClick={calculateEMI}
            className="bg-blue-500 text-white px-4 py-2 rounded"
          >
            Calculate
          </button>
        </div>
        <div>
          <div className="mb-4">
            <h2 className="text-xl font-bold">Results</h2>
            <p>Monthly EMI: ₹ {parseFloat(monthlyEMI).toLocaleString()}</p>
            <p>Total Principal Amount: ₹ {loanAmount.toLocaleString()}</p>
            <p>Total Interest: ₹ {parseFloat(totalInterest).toLocaleString()}</p>
            <p>Total Amount (Principal + Interest): ₹ {parseFloat(totalAmount).toLocaleString()}</p>
          </div>
          <div>
            <h2 className="text-xl font-bold">Breakdown</h2>
            <div className="flex justify-center">
              <Pie data={data} options={{ maintainAspectRatio: false }} width={300} height={300} />
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-4">Amortization Schedule</h2>
        {amortizationSchedule.length > 0 && (
          <div className="flex flex-col space-y-4">
            {Array.from(new Set(amortizationSchedule.map(item => item.year))).map((year, idx) => (
              <div key={idx} className="mb-4 border rounded-md shadow-md">
                <div
                  className={`cursor-pointer text-lg font-semibold bg-gray-100 p-4 flex justify-between items-center ${activeYear === year ? 'bg-blue-100' : ''}`}
                  onClick={() => handleYearToggle(year)}
                >
                  <span>{year}</span>
                  <span>{activeYear === year ? '-' : '+'}</span>
                </div>
                {activeYear === year && (
                  <div className="overflow-x-auto">
                    <table className="min-w-full bg-white rounded-md shadow-md">
                      <thead>
                        <tr>
                          <th className="py-2 px-4 border-b">Month</th>
                          <th className="py-2 px-4 border-b">Principal Paid</th>
                          <th className="py-2 px-4 border-b">Interest Charged</th>
                          <th className="py-2 px-4 border-b">Total Payment</th>
                          <th className="py-2 px-4 border-b">Balance</th>
                        </tr>
                      </thead>
                      <tbody>
                        {amortizationSchedule.filter(item => item.year === year).map((item, idx) => (
                          <tr key={idx}>
                            <td className="py-2 px-4 border-b">{new Date(0, item.month - 1).toLocaleString('default', { month: 'short' })}</td>
                            <td className="py-2 px-4 border-b">₹ {item.principalPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.interestPaid.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.totalPayment.toFixed(2).toLocaleString()}</td>
                            <td className="py-2 px-4 border-b">₹ {item.balance.toFixed(2).toLocaleString()}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
     <div className="flex flex-wrap lg:px-6 md:px-6 px-0 py-6" >
     <div className="w-full md:w-2/3 p-4 mx-auto">
     <div className="container mx-auto py-4">
          <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
            Plan Your Bank of Baroda Car Loan Payments with TheFinMaster’s EMI Calculator
          </h2>
          <p className="text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-2">
            Planning a car purchase with a Bank of Baroda car loan? TheFinMaster’s comprehensive Bank of Baroda Car Loan EMI Calculator is your go-to financial planning tool. Whether you're buying a budget-friendly hatchback or a luxury SUV, knowing your EMI (Equated Monthly Installment) in advance helps you plan your finances responsibly. This calculator gives you a detailed understanding of your monthly outgo, total interest, and repayment schedule—all at your fingertips.
          </p>
</div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is a Car Loan EMI?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              A Car Loan EMI (Equated Monthly Installment) is the fixed amount you pay each month towards repaying your car loan. It comprises two key components:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Principal Amount</strong> – the actual loan amount borrowed</li>
              <li><strong>Interest</strong> – the fee charged by the bank for lending you money</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              These EMIs are paid over a tenure ranging from 12 to 84 months depending on your eligibility and agreement with the bank. The EMI remains fixed unless you choose a floating interest rate or prepay a portion of the loan. The higher the interest rate and the longer the loan tenure, the greater the interest you will pay overall.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Understanding your EMI helps you balance your budget and make an informed decision without straining your monthly cash flow.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is Bank of Baroda Car Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The Bank of Baroda Car Loan EMI Calculator by TheFinMaster is a user-friendly online tool tailored specifically for Bank of Baroda loan applicants. It helps you calculate your monthly EMI based on loan amount, tenure, and interest rate applicable at Bank of Baroda. This customized calculator helps you:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>Plan repayments with complete clarity</li>
              <li>Adjust loan tenure and amount to suit your needs</li>
              <li>Compare EMI structures before making a final loan decision</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Instead of manually calculating EMI using complex formulas, this calculator delivers accurate and instant results. It's especially useful if you're comparing different loan options or exploring how tenure or interest changes impact your overall repayment.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Why Use TheFinMaster’s Bank of Baroda Car Loan EMI Calculator?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              TheFinMaster’s EMI calculator for Bank of Baroda is more than just a simple utility. Here’s why it stands out:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Tailored for Bank of Baroda:</strong> Based on the current car loan offerings and interest rates from BoB</li>
              <li><strong>Instant Calculations:</strong> Get EMI results instantly—no waiting or registration needed</li>
              <li><strong>Amortization Chart:</strong> View your full loan repayment schedule</li>
              <li><strong>Interest Breakdown:</strong> Understand the total interest outgo over the loan tenure</li>
              <li><strong>Customizable Inputs:</strong> Change tenure, loan amount, or interest rate as per your financial goals</li>
              <li><strong>Budget Planning:</strong> Helps you decide how much you can afford monthly</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The tool brings accuracy and simplicity together, helping you visualize and plan your loan repayment journey efficiently.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              How Does the Bank of Baroda Car Loan EMI Calculator Work?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              The EMI is calculated using the following formula:
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              EMI = [P x R x (1+R)^N] / [(1+R)^N – 1]
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Where:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>P = Principal loan amount</li>
              <li>R = Monthly interest rate (annual interest rate / 12 / 100)</li>
              <li>N = Loan tenure in months</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Example Calculation:</strong><br />
              Let’s say you take a car loan of ₹10,00,000 from Bank of Baroda at an interest rate of 9% for a tenure of 5 years (60 months):<br />
              P = ₹10,00,000<br />
              R = 9%/12 = 0.0075<br />
              N = 60 months<br />
              EMI = [10,00,000 x 0.0075 x (1+0.0075)^60] / [(1+0.0075)^60 – 1]<br />
              Your EMI would be approximately ₹20,758 per month.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This EMI includes both interest and principal repayment. Over time, the principal component increases while the interest portion decreases.
            </p>
          </div>
          <div className="w-full flex justify-center items-center my-6 px-4">
          <div className="w-full max-w-[984px]">

     
        <AdBanner displayOrder="3" />
        </div>
         
        </div>
          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              What is the Amortization Schedule?
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              An amortization schedule is a detailed table that outlines every EMI payment throughout the loan tenure. It displays:
            </p>
            <ul className="list-disc pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li>EMI amount</li>
              <li>Principal repaid</li>
              <li>Interest paid</li>
              <li>Outstanding loan balance</li>
            </ul>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This schedule helps you understand how your monthly payment is distributed. Initially, a large portion of the EMI goes towards interest. Over time, the share of principal increases.
            </p>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <strong>Sample 12-Month Amortization Schedule:</strong>
            </p>
            {/* <div className="overflow-x-auto">
              <table className="w-full text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg mt-4 border-collapse">
                <thead>
                  <tr className="bg-gray-100">
                    <th className="border px-4 py-2 text-left">Month</th>
                    <th className="border px-4 py-2 text-left">EMI (₹)</th>
                    <th className="border px-4 py-2 text-left">Interest (₹)</th>
                    <th className="border px-4 py-2 text-left">Principal (₹)</th>
                    <th className="border px-4 py-2 text-left">Balance (₹)</th>
                  </tr>
                </thead>
                <tbody>
                  <tr>
                    <td className="border px-4 py-2">1</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">7,500</td>
                    <td className="border px-4 py-2">13,258</td>
                    <td className="border px-4 py-2">9,86,742</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">2</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">7,400</td>
                    <td className="border px-4 py-2">13,358</td>
                    <td className="border px-4 py-2">9,73,384</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">3</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">7,301</td>
                    <td className="border px-4 py-2">13,457</td>
                    <td className="border px-4 py-2">9,59,927</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">4</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">7,199</td>
                    <td className="border px-4 py-2">13,559</td>
                    <td className="border px-4 py-2">9,46,368</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">5</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">7,098</td>
                    <td className="border px-4 py-2">13,660</td>
                    <td className="border px-4 py-2">9,32,708</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">6</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,995</td>
                    <td className="border px-4 py-2">13,763</td>
                    <td className="border px-4 py-2">9,18,945</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">7</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,892</td>
                    <td className="border px-4 py-2">13,866</td>
                    <td className="border px-4 py-2">9,05,079</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">8</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,788</td>
                    <td className="border px-4 py-2">13,970</td>
                    <td className="border px-4 py-2">8,91,109</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">9</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,683</td>
                    <td className="border px-4 py-2">14,075</td>
                    <td className="border px-4 py-2">8,77,034</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">10</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,578</td>
                    <td className="border px-4 py-2">14,180</td>
                    <td className="border px-4 py-2">8,62,854</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">11</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,472</td>
                    <td className="border px-4 py-2">14,286</td>
                    <td className="border px-4 py-2">8,48,568</td>
                  </tr>
                  <tr>
                    <td className="border px-4 py-2">12</td>
                    <td className="border px-4 py-2">20,758</td>
                    <td className="border px-4 py-2">6,366</td>
                    <td className="border px-4 py-2">14,392</td>
                    <td className="border px-4 py-2">8,34,176</td>
                  </tr>
                </tbody>
              </table>
            </div> */}
            <div className="mt-6">
  {/* Table view for medium and up */}
  <div className="hidden md:block overflow-x-auto">
    <table className="w-full text-lg text-gray-600 mt-4 border-collapse">
      <thead>
        <tr className="bg-gray-100">
          <th className="border px-4 py-2 text-left">Month</th>
          <th className="border px-4 py-2 text-left">EMI(₹)</th>
          <th className="border px-4 py-2 text-left">Interest  (₹)</th>
          <th className="border px-4 py-2 text-left">Principal  (₹)</th>
          <th className="border px-4 py-2 text-left"> Balance (₹)</th>
        </tr>
      </thead>
      <tbody>
        {[
          
       
          ["1", "₹20,758", "₹7,500", "₹13,258", "₹9,86,742"],
          ["2", "₹20,758", "₹7,400", "₹13,358", "₹9,73,384"],
          ["3", "₹20,758", "₹7,301", "₹13,457", "₹9,59,927"],
          ["4", "₹20,758", "₹7,199", "₹13,559", "₹9,46,368"],
          ["5", "₹20,758", "₹7,098", "₹13,660", "₹9,32,708"],
          ["6", "₹20,758", "₹6,995", "₹13,763", "₹9,18,945"],
          ["7", "₹20,758", "₹6,892", "₹13,866", "₹9,05,079"],
          ["8", "₹20,758", "₹6,788", "₹13,970", "₹8,91,109"],
          ["9", "₹20,758", "₹6,683", "₹14,075", "₹8,77,034"],
          ["10", "₹20,758", "₹6,578", "₹14,180", "₹8,62,854"],
          ["11", "₹20,758", "₹6,472", "₹14,286", "₹8,48,568"],
          ["12", "₹20,758", "₹6,366", "₹14,392", "₹8,34,176"]
     
        ].map(([month, emi, interest, principal, balance], index) => (
          <tr key={index}>
            <td className="border px-4 py-2">{month}</td>
            <td className="border px-4 py-2">{emi}</td>
            <td className="border px-4 py-2">{interest}</td>
            <td className="border px-4 py-2">{principal}</td>
            <td className="border px-4 py-2">{balance}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </div>

  {/* Card layout for small screens */}
  <div className="md:hidden space-y-4 mt-4">
    {[
           ["1", "₹14,560", "₹5,250", "₹9,310", "₹6,90,690"],
           ["2", "₹14,560", "₹5,180", "₹9,380", "₹6,81,310"],
           ["3", "₹14,560", "₹5,110", "₹9,450", "₹6,71,860"],
           ["4", "₹14,560", "₹5,038", "₹9,522", "₹6,62,338"],
           ["5", "₹14,560", "₹4,967", "₹9,593", "₹6,52,745"],
           ["6", "₹14,560", "₹4,895", "₹9,665", "₹6,43,080"],
           ["7", "₹14,560", "₹4,823", "₹9,737", "₹6,33,343"],
           ["8", "₹14,560", "₹4,750", "₹9,810", "₹6,23,533"],
           ["9", "₹14,560", "₹4,676", "₹9,884", "₹6,13,649"],
           ["10", "₹14,560", "₹4,602", "₹9,958", "₹6,03,691"],
           ["11", "₹14,560", "₹4,528", "₹10,032", "₹5,93,659"],
           ["12", "₹14,560", "₹4,452", "₹10,108", "₹5,83,551"]
    ].map(([month, emi, interest, principal, balance], index) => (
      <div key={index} className="bg-white shadow rounded-xl p-4 text-sm text-gray-700 space-y-1 border">
        <div><span className="font-semibold">Month:</span> {month}</div>
        <div><span className="font-semibold">EMI  (₹):</span> {emi}</div>
        <div><span className="font-semibold">Interest  (₹):</span> {interest}</div>
        <div><span className="font-semibold">Principal  (₹):</span> {principal}</div>
        <div><span className="font-semibold"> Outstanding(₹):</span> {balance}</div>
      </div>
    ))}
  </div>
</div>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              This schedule continues until the full repayment is complete.
            </p>
          </div>

          <div className="container mx-auto py-4">
            <h2 className="text-xl font-medium bg-blue-100 border-l-4 border-blue-600 pl-4 py-2">
              Factors Affecting Your Car Loan EMI
            </h2>
            <p className="mt-4 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              Several variables impact your Bank of Baroda car loan EMI:
            </p>
            <ul className="list-decimal pl-6 mt-2 text-lg text-gray-600 sm:text-xl md:text-lg lg:text-xl xl:text-lg">
              <li><strong>Loan Amount:</strong><br />
                Higher principal leads to higher EMIs. Borrowing ₹5 lakhs vs ₹10 lakhs can double your monthly obligation.
              </li>
              <li><strong>Interest Rate:</strong><br />
                Interest rates can vary based on your credit score, loan tenure, and profile. A 1% difference in interest can significantly affect EMI.
              </li>
              <li><strong>Loan Tenure:</strong><br />
                Longer tenure reduces EMI but increases total interest outgo. Shorter tenure means higher EMI but lower interest cost.
              </li>
              <li><strong>Credit Profile:</strong><br />
                Strong credit history may get you preferential interest rates, reducing EMI.
              </li>
              <li><strong>Down Payment:</strong><br />
                A higher down payment reduces the principal amount, resulting in a smaller EMI.
              </li>
              <li><strong>Prepayments:</strong><br />
                Part-prepayments or foreclosure can reduce EMI or shorten tenure, decreasing your overall interest.
              </li>
            </ul>
          </div>
        </div>

     <div className="w-full md:w-1/3 p-4">
       <div className="bg-white shadow-md rounded-lg overflow-hidden">
         <div className="bg-blue-100 px-4 py-2 border-b border-blue-600 ">
           <h2 className="text-lg font-semibold ">Popular Categories</h2>
         </div>
         <div className="p-2 ">
         <ul>
                                <Link to='/financial-tools-calculators/swp-calculator'>
                                    <li className="py-2  hover:bg-slate-100 border-b border-gray-300">SWP Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/mutul-fund-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Mutual Fund Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/sukanya-samriddhi-yojana-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Samriddhi Yojana Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/fd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">FD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/rd-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">RD Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/nps-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NPS Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/hra-exemption-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">HRA Exemption Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/retirement-planning-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Retirement Planning Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">EMI Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/simple-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Simple Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/compound-interest-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Compound Interest Calculator</li>

                                </Link><Link to='/financial-tools-calculators/nsc-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">NSC Calculator</li>

                                </Link><Link to='/financial-tools-calculators/step-up-sip-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Step Up Sip Calculator</li>

                                </Link><Link to='/financial-tools-calculators/income-tax-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Income Tax Calculator</li>
                                    
                                </Link><Link to='/financial-tools-calculators/home-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Home Loan Emi Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/car-loan-emi-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Car Loan Emi Calculator</li>
                                </Link>
                                {/* {categories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
                            </ul>
                        </div>
                    </div>

                        {/* Ad Banner */}
  <div className="mt-4">
    <div className="bg-white shadow-md rounded-lg overflow-hidden">
      <div className="p-3 w-full h-auto rounded-md object-cover">
        <AdBanner displayOrder="2" />
      </div>
    </div>
  </div>
                    <div className="bg-white shadow-md rounded-lg overflow-hidden mt-4">
                        <div className="bg-blue-100 px-4 py-2 border-b border-blue-600">
                            <h2 className="text-lg font-semibold">More Categories</h2>
                        </div>
                        <div className="p-2">
                        <ul>
                                <Link to='/financial-tools-calculators/gratuity-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Gratuity Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/APY-calculator'>
                                    <li className="py-2 border- hover:bg-slate-100 border-gray-300">APY Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/cagr-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">CAGR Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/gst-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">GST Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/flat-vs-reducing-rate-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Flat Vs Reducing Rate Calculator</li>
                                </Link>
                                {/* <Link to='/financial-tools-calculators/equity-margin-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Equity Margin Calculator</li>
                                </Link> */}
                                <Link to='/financial-tools-calculators/inflation-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Inflation Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/salary-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Salary Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/brokerage-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">Brokerage Calculator</li>
                                </Link>
                                <Link to='/financial-tools-calculators/tds-calculator'>
                                    <li className="py-2 border-b hover:bg-slate-100 border-gray-300">TDS Calculator</li>
                                </Link>
             {/* {moreCategories.map(category => (
       <Link key={category.id} to={`/category/${category.id}`}>
         <li className="py-2 border-b border-gray-300">{category.name}</li>
       </Link>
     ))} */}
           </ul>
         </div>
       </div>

     </div>

   </div>
   </div>
   <div className="max-w-4xl mx-auto lg:px-6 md:px-6 px-2 py-6">
                <h2 className="text-center text-2xl md:text-2xl lg:text-3xl font-bold mb-8">Frequently Asked Questions</h2>
                <div className="space-y-4">
                    {faqs.map((faq, index) => (
                        <div key={index} className="border rounded-lg overflow-hidden shadow-md">
                            <button
                                onClick={() => toggleAccordion(index)}
                                className="w-full p-4 text-left text-lg font-semibold focus:outline-none flex justify-between items-center"
                            >
                                {faq.question}
                                <Icon id={index} open={activeIndex} />
                            </button>
                            {activeIndex === index && (
                                <div className="p-4 bg-gray-100">
                                    <p className="text-gray-700">{faq.answer}</p>
                                </div>
                            )}
                        </div>
                    ))}
                </div>
            </div>
   </>
  );
};

export default BobCarLoanEmiCalculator ;
